import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BookIcon, EyeIcon, EyeOffIcon, CheckIcon } from 'lucide-react';
import { useDarkMode } from '../context/DarkModeContext';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
const CreateReaderAccount = () => {
  const {
    darkMode
  } = useDarkMode();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    acceptTerms: false
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setIsSuccess(true);
      console.log('Reader account created:', formData);
    }, 1500);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  if (isSuccess) {
    return <div className={`min-h-screen flex items-center justify-center px-4 ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`} data-id="element-9104" data-mp="3ejvmksluv9l7">
        <div className={`max-w-md w-full p-8 rounded-lg shadow-lg text-center ${darkMode ? 'bg-gray-800' : 'bg-white'}`} data-id="element-9105" data-mp="35ks3vpqlow78">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4" data-id="element-9106" data-mp="3alfuwbetxd1g">
            <CheckIcon className="h-6 w-6 text-green-600" data-id="element-9107" data-mp="2voygfbbcfiao" />
          </div>
          <h2 className={`text-2xl font-bold mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-9108" data-mp="30mgtndwe8joh">
            Account Created!
          </h2>
          <p className={`mb-6 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-9109" data-mp="yuu0b5p14cou">
            Welcome to LitLaunch. Let's set up your profile so you can start
            discovering books.
          </p>
          <Link to="/profile/settings" data-id="element-9110" data-mp="se281h9g4zxd">
            <Button className="w-full bg-indigo-600 hover:bg-indigo-700 text-white" data-id="element-9111" data-mp="sd0m2hqw6t0v">
              Complete Your Profile
            </Button>
          </Link>
        </div>
      </div>;
  }
  return <div className={`min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`} data-id="element-9112" data-mp="jfgllb0ut0rb">
      <div className={`max-w-md w-full space-y-8 p-10 rounded-xl shadow-lg ${darkMode ? 'bg-gray-800' : 'bg-white'}`} data-id="element-9113" data-mp="1b4jmqhxg1uzq">
        <div className="text-center" data-id="element-9114" data-mp="16cjtf8bvq0c4">
          <Link to="/" className="flex items-center justify-center mb-6" data-id="element-9115" data-mp="12chp0rerest5">
            <BookIcon className="h-8 w-8 text-indigo-600" data-id="element-9116" data-mp="12af2wigq9jtp" />
            <span className={`ml-2 text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-9117" data-mp="1yvfljz0bhqgh">
              LitLaunch
            </span>
          </Link>
          <h2 className={`mt-2 text-3xl font-extrabold ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-9118" data-mp="3cr77ujq558u6">
            Create Reader Account
          </h2>
          <p className={`mt-2 text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-9119" data-mp="3lr3t0bdbnpkh">
            Join our community of book lovers
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-9120" data-mp="3qnu6qs1nm92q">
          <div className="space-y-4" data-id="element-9121" data-mp="3vorvxol303dq">
            <div data-id="element-9122" data-mp="4j084vus12u3">
              <label htmlFor="username" className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`} data-id="element-9123" data-mp="4igp1bte48eh">
                Username
              </label>
              <Input id="username" name="username" required value={formData.username} onChange={handleChange} className={darkMode ? 'bg-gray-700 border-gray-600 text-white focus:ring-indigo-500' : ''} placeholder="bookworm123" data-id="element-9124" data-mp="da0k9nytk04p" />
            </div>

            <div data-id="element-9125" data-mp="jckls98qeltw">
              <label htmlFor="email" className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`} data-id="element-9126" data-mp="jd3tyy8kxvuq">
                Email Address
              </label>
              <Input id="email" name="email" type="email" required value={formData.email} onChange={handleChange} className={darkMode ? 'bg-gray-700 border-gray-600 text-white focus:ring-indigo-500' : ''} placeholder="you@example.com" data-id="element-9127" data-mp="3mu2j3mqvoag2" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-9128" data-mp="172ogts7utd9a">
              <div data-id="element-9129" data-mp="174hpfd2127jx">
                <label htmlFor="password" className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`} data-id="element-9130" data-mp="1el4pb1431go4">
                  Password
                </label>
                <div className="relative" data-id="element-9131" data-mp="15mkcggl7e17t">
                  <Input id="password" name="password" type={showPassword ? 'text' : 'password'} required value={formData.password} onChange={handleChange} className={darkMode ? 'bg-gray-700 border-gray-600 text-white focus:ring-indigo-500' : ''} data-id="element-9132" data-mp="19ml452xbc8wt" />
                  <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-500" onClick={() => setShowPassword(!showPassword)} data-id="element-9133" data-mp="2gb1g4ttl9eic">
                    {showPassword ? <EyeOffIcon className="h-4 w-4" data-id="element-9134" data-mp="2qweje7ago87k" /> : <EyeIcon className="h-4 w-4" data-id="element-9135" data-mp="2quajs1jlhvd3" />}
                  </button>
                </div>
              </div>

              <div data-id="element-9136" data-mp="2gyqnhe14cunt">
                <label htmlFor="confirmPassword" className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`} data-id="element-9137" data-mp="2gx5wfye0jtup">
                  Confirm Password
                </label>
                <div className="relative" data-id="element-9138" data-mp="236argx6mxwwe">
                  <Input id="confirmPassword" name="confirmPassword" type={showConfirmPassword ? 'text' : 'password'} required value={formData.confirmPassword} onChange={handleChange} className={darkMode ? 'bg-gray-700 border-gray-600 text-white focus:ring-indigo-500' : ''} data-id="element-9139" data-mp="237c250jqohdl" />
                  <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-500" onClick={() => setShowConfirmPassword(!showConfirmPassword)} data-id="element-9140" data-mp="1j6iwvlhqz8ku">
                    {showConfirmPassword ? <EyeOffIcon className="h-4 w-4" data-id="element-9141" data-mp="10dosflhr2yuv" /> : <EyeIcon className="h-4 w-4" data-id="element-9142" data-mp="10blqc33bpf9s" />}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-start" data-id="element-9143" data-mp="1a52mhdqxn6gm">
            <div className="flex items-center h-5" data-id="element-9144" data-mp="colypf9udfk0">
              <input id="acceptTerms" name="acceptTerms" type="checkbox" required checked={formData.acceptTerms} onChange={handleChange} className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded" data-id="element-9145" data-mp="co3vtzsoc334" />
            </div>
            <div className="ml-3 text-sm" data-id="element-9146" data-mp="25scz03ctbny0">
              <label htmlFor="acceptTerms" className={darkMode ? 'text-gray-300' : 'text-gray-600'} data-id="element-9147" data-mp="25q09940tc9ae">
                I agree to the{' '}
                <Link to="/terms" className="font-medium text-indigo-600 hover:text-indigo-500" data-id="element-9148" data-mp="2er87xn78rc50">
                  Terms of Service
                </Link>{' '}
                and{' '}
                <Link to="/privacy" className="font-medium text-indigo-600 hover:text-indigo-500" data-id="element-9149" data-mp="2jjhquj9xvbxs">
                  Privacy Policy
                </Link>
              </label>
            </div>
          </div>

          <Button type="submit" disabled={isLoading} className={`w-full py-2.5 text-base font-medium ${isLoading ? 'opacity-70 cursor-not-allowed' : ''}`} data-id="element-9150" data-mp="2tj8m4n6bpuyx">
            {isLoading ? 'Creating Account...' : 'Create Account'}
          </Button>

          <div className="mt-6 text-center" data-id="element-9151" data-mp="334rs4oz3cguq">
            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-9152" data-mp="384e46v36nr1y">
              Already have an account?{' '}
              <Link to="/login" className="font-medium text-indigo-600 hover:text-indigo-500" data-id="element-9153" data-mp="2tdx7fp1htpbe">
                Sign in
              </Link>
            </p>
          </div>
        </form>
      </div>
    </div>;
};
export default CreateReaderAccount;